document.addEventListener('DOMContentLoaded', function () {
  renderQuoteItems();

  var form = document.getElementById('QuoteRequestForm');
  if (form) {
    form.addEventListener('submit', handleQuoteSubmit);
  }
});

function renderQuoteItems() {
  var quoteList = JSON.parse(localStorage.getItem('quoteCart') || '[]');
  var container = document.getElementById('QuoteCartItems');

  if (quoteList.length === 0) {
    container.innerHTML = '<p>Your quote list is empty. Go back and add some products first.</p>';
    return;
  }

  var html = '<table class="quote-table"><thead><tr>' +
    '<th>Image</th><th>Product</th><th>SKU</th><th></th>' +
    '</tr></thead><tbody>';

  quoteList.forEach(function (item, index) {
    html += '<tr>' +
      '<td><img src="' + item.image + '" width="60"></td>' +
      '<td>' + item.title + '</td>' +
      '<td>' + (item.sku || '-') + '</td>' +
      '<td><button type="button" class="quote-item-remove" data-index="' + index + '">Remove</button></td>' +
      '</tr>';
  });

  html += '</tbody></table>';
  container.innerHTML = html;

  container.querySelectorAll('.quote-item-remove').forEach(function (btn) {
    btn.addEventListener('click', function () {
      removeQuoteItem(parseInt(btn.dataset.index));
    });
  });
}

function removeQuoteItem(index) {
  var quoteList = JSON.parse(localStorage.getItem('quoteCart') || '[]');
  quoteList.splice(index, 1);
  localStorage.setItem('quoteCart', JSON.stringify(quoteList));
  renderQuoteItems();
}

function handleQuoteSubmit(e) {
  e.preventDefault();

  var quoteList = JSON.parse(localStorage.getItem('quoteCart') || '[]');
  if (quoteList.length === 0) {
    document.getElementById('QuoteFormMessage').innerText = 'Please add at least one product before submitting.';
    return;
  }

  var form = e.target;
  var msgEl = document.getElementById('QuoteFormMessage');
  var submitBtn = document.getElementById('QuoteSubmitBtn');

  var productsHtml = '<table style="width:100%;border-collapse:collapse;">';
  quoteList.forEach(function (item) {
    var imgUrl = item.image;
    if (imgUrl && imgUrl.indexOf('//') === 0) {
      imgUrl = 'https:' + imgUrl;
    }
    productsHtml += '<tr>' +
      '<td style="padding:6px;"><img src="' + imgUrl + '" width="60"></td>' +
      '<td style="padding:6px;">' + item.title + ' (SKU: ' + (item.sku || '-') + ')</td>' +
      '<td style="padding:6px;">Qty: ' + item.quantity + '</td>' +
      '</tr>';
  });
  productsHtml += '</table>';

  var params = {
    reference: 'PI-' + Date.now(),
    customer_name: form.full_name.value,
    company: form.company.value,
    email: form.email.value,
    phone: form.phone.value,
    address: form.address1.value + ', ' + (form.address2.value ? form.address2.value + ', ' : '') +
      form.city.value + ', ' + form.state.value + ' - ' + form.zip.value + ', ' + form.country.value,
    gst: form.gst.value,
    notes: form.notes.value,
    products_html: productsHtml
  };

  submitBtn.disabled = true;
  submitBtn.innerText = 'Submitting...';

  if (typeof emailjs !== 'undefined') {
    emailjs.send('service_cje7orb', 'template_h58it9g', params)
      .then(function () {
        msgEl.innerText = 'Thank you! Your quote request has been submitted. We will get back to you shortly.';
        localStorage.removeItem('quoteCart');
        form.reset();
        renderQuoteItems();
        submitBtn.innerText = 'Submit Quote Request';
        submitBtn.disabled = false;
      })
      .catch(function (err) {
        console.error(err);
        msgEl.innerText = 'Something went wrong. Please try again or contact us directly.';
        submitBtn.innerText = 'Submit Quote Request';
        submitBtn.disabled = false;
      });
  } else {
    console.error('EmailJS not loaded. Check that the SDK script is added in theme.liquid.');
    msgEl.innerText = 'Email service not configured yet. Please contact the site admin.';
    submitBtn.innerText = 'Submit Quote Request';
    submitBtn.disabled = false;
  }
}